import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/education/data";
import { motion } from "framer-motion";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function BallisticMissile() {
  const products = [
    "Plagiarism Detection and Academic Integrity Software",
   

  ];
  const data = {
    image: "/industries/education/plagiarism.jpg", // Replace with the appropriate image URL
    intro: `Uphold academic integrity and foster originality with our Plagiarism Detection and Academic Integrity Software. Tailored for educational institutions, our software provides robust tools to identify and address instances of plagiarism, ensuring a fair and ethical learning environment.`,
    keyFeatures: [
      {
        title: "Advanced plagiarism detection algorithms",
        content: "Utilize cutting-edge algorithms to identify instances of plagiarism in academic work.",
      },
      {
        title: "Integration with learning management systems",
        content: "Seamlessly integrate with learning management systems for efficient use within educational workflows.",
      },
      {
        title: "Automated similarity reports",
        content: "Generate detailed similarity reports automatically, aiding educators in addressing and preventing plagiarism effectively.",
      },
      {
        title: "Customizable academic integrity policies",
        content: "Tailor academic integrity policies to meet the specific needs of your educational institution.",
      },
      {
        title: "Educational resources on proper citation and attribution",
        content: "Provide resources to educate students on proper citation and attribution practices.",
      },
    ],
    howItWorks: `Explore how our software employs cutting-edge algorithms to analyze academic work, producing detailed similarity reports that help educators address and prevent plagiarism effectively.`,
  
    benefits: {
      title: "The advantages of our Plagiarism Detection and Academic Integrity Software",
      data: [
        "Ensures academic integrity and originality.",
        "Advanced plagiarism detection for various types of content.",
        "Seamless integration with learning management systems.",
        "Automated generation of detailed similarity reports.",
        "Customizable policies to address plagiarism instances.",
      ],
    },
    industries:
      "Critical for educational institutions, universities, and organizations committed to upholding academic honesty and integrity.",
    stories: `Discover how our Plagiarism Detection and Academic Integrity Software have contributed to creating an environment that prioritizes academic honesty and originality.`,
    contactUs: `Connect with our experts to explore how our software can be integrated into your educational institution for effective plagiarism detection and academic integrity maintenance.`,
    technology: `Learn how our software seamlessly integrates with various learning management systems, academic databases, and educational technologies, creating a comprehensive academic integrity ecosystem.`,
    support: `Access training resources and our support system for effective implementation and optimal use of Plagiarism Detection and Academic Integrity Software.`,
    industry: `Understand how our software aligns with industry standards and regulatory requirements for academic integrity in education.`,
    events:
      "Stay updated on relevant industry events and explore collaboration opportunities in plagiarism detection and academic integrity software technology research.",
    blog: `Read articles, case studies, and expert opinions in our plagiarism detection and academic integrity software blog and knowledge hub.`,
    careers: `Explore opportunities to contribute to the advancement of plagiarism detection and academic integrity software technology.`,
  };
  
  
  const content = "Ignite innovation in education with us! Whether you're shaping the future of e-learning, educational technology, or any facet of the education sector, we offer customized solutions. Our expertise spans projects of all sizes, ensuring our educational solutions seamlessly align with your vision, budget, and scope."
  return (
    <>
    <Head>
    <title>Plagiarism Detection and Academic Integrity Software | Techbrain Networks</title>
    <meta name="description" content="Ensure academic integrity with Techbrain Networks Plagiarism Detection Software, designed to identify and prevent plagiarism in educational content and research." />
    <meta name="keywords" content="plagiarism detection, academic integrity, educational software, research tools, Techbrain Networks" />
    <meta property="og:title" content="Plagiarism Detection and Academic Integrity Software | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks offers Plagiarism Detection and Academic Integrity Software to help institutions maintain academic standards by detecting and preventing plagiarism." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/education/products/plagiarism-detection-and-academic-integrity-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Plagiarism Detection and Academic Integrity Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Plagiarism Detection and Academic Integrity Software | Techbrain Networks" />
    <meta name="twitter:description" content="Maintain academic integrity with Techbrain Networks Plagiarism Detection Software, designed to identify and prevent plagiarism in educational research and content." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/education/products/plagiarism-detection-and-academic-integrity-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Plagiarism Detection and Academic Integrity Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Ensure academic integrity with Techbrain Networks Plagiarism Detection Software, designed to identify and prevent plagiarism in educational content and research.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/education/products/plagiarism-detection-and-academic-integrity-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
        <link rel="icon" href="/favicon.png" />
</Head>

      <AppbarIndustry title={"Education"} homeLink={'/industries/education'} link={'/industries/education/products'} />
      <StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#6897E4"} />
      <HeroSection img={"/industries/education/plagiarism-detection-and-academic-integrity-software.avif"}>Plagiarism Detection and Academic Integrity Software
</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#0B1829",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#6897E4"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#6897E4",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          component={motion.div}
          initial={{ opacity: 0,y:20 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
          viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#6897E4"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        

         

        {/* Future Developments and Innovations*/}
 
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in radiation shielding simulation technology
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0B1829",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#6897E4"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

           
        <Box
                component={motion.div}
                initial={{ opacity: 0,y:20 }}
                whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
                viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#6897E4",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
           <Box
            sx={{
              width: ["100%", "100%", "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#6897E4"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#6897E4"} bg={"#0B1829"} />
    </>
  );
}

export default BallisticMissile;
